function SkillsContent({state}) {
  return (
    <div className="cards-block-button-desc">{state.desc}</div>
  );
}

export default SkillsContent;